import { OverdueDebtComponent } from './overdue-debt/overdue-debt.component';
export var powerBIDashboardRoutes = [
    {
        path: 'power-bi-dashboard',
        children: [
            {
                path: 'overdue-debt',
                component: OverdueDebtComponent
            }
        ],
    },
];
var PowerBiDashboardRoutingModule = (function () {
    function PowerBiDashboardRoutingModule() {
    }
    return PowerBiDashboardRoutingModule;
}());
export { PowerBiDashboardRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/power-bi-dashboard/power-bi-dashboard-routing.module.ts.pre-build-optimizer.js